import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

const HOURS = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"));
const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];

export function TimePicker({ label, value, onChange, testid }) {
  const [hh = "", mm = ""] = (value || "").split(":");

  const update = (h, m) => {
    if (h !== "" && m !== "") onChange(`${h}:${m}`);
    else onChange(`${h || ""}${h !== "" || m !== "" ? ":" : ""}${m || ""}`);
  };

  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <div className="flex items-center gap-2">
        <Select value={hh} onValueChange={(h) => update(h, mm)}>
          <SelectTrigger className="h-12 text-base font-heading font-semibold" data-testid={`${testid}-hour`}>
            <SelectValue placeholder="Ora" />
          </SelectTrigger>
          <SelectContent className="max-h-64">
            {HOURS.map((h) => (<SelectItem key={h} value={h}>{h}</SelectItem>))}
          </SelectContent>
        </Select>
        <span className="text-xl font-bold text-slate-400">:</span>
        <Select value={mm} onValueChange={(m) => update(hh, m)}>
          <SelectTrigger className="h-12 text-base font-heading font-semibold" data-testid={`${testid}-minute`}>
            <SelectValue placeholder="Min" />
          </SelectTrigger>
          <SelectContent className="max-h-64">
            {MINUTES.map((m) => (<SelectItem key={m} value={m}>{m}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
